import { ExperienceSource } from 'model/IExperience';

export const getCustomizationLink = (
  baseUrl: string,
  experience: ExperienceSource,
  forceHost: { id: string } | null = null,
) => {
  let contactedHost: { id: string };
  if (forceHost) {
    contactedHost = forceHost;
  } else if (experience.is_originals) {
    contactedHost =
      experience.hosts.length > 0
        ? experience.hosts.reduce((prevHost, nextHost) => {
            return prevHost.personalizedOfferOrder >
              nextHost.personalizedOfferOrder
              ? prevHost
              : nextHost;
          })
        : experience.account;
  } else {
    contactedHost = experience.account;
  }

  // do not return if there is no contacted host set
  if (!contactedHost) {
    return null;
  }

  return `${baseUrl}/contact/${contactedHost.id}/personalize-offer/`;
};
